'use client'

import { useEffect, useState } from 'react'
import {
  attributionAllowed,
  onConsentChanged,
  strictConsentOn,
} from '../lib/consent'

// Whether this page may store the attribution tokens (the ad networks' and CrakRevenue's ids, pc_ref's copy in
// storage) right now: lib/consent.js attributionAllowed(). Always true while the strict consent switch
// (NEXT_PUBLIC_STRICT_CONSENT) is off, so an effect that depends on it runs exactly as it did before. With the switch
// on it follows the banner: false until the visitor allows tracking, then true on the same page, so a capture whose
// URL parameters are still there records them when they accept.
export default function useAttributionAllowed() {
  const [allowed, setAllowed] = useState(attributionAllowed)

  useEffect(() => {
    if (!strictConsentOn()) return undefined
    const update = () => setAllowed(attributionAllowed())
    update()
    return onConsentChanged(update)
  }, [])

  return allowed
}
